/**
 * Structured error response from backend API endpoints
 * Used to distinguish different types of authentication failures
 */
export interface ApiErrorResponse {
  /** Generic error identifier (e.g., "unauthorized", "invalid_grant") */
  error?: string;

  /** Human-readable error description. Used to detect "User not found" scenario. */
  error_description?: string;

  /** Alternative error message field (fallback if error_description not present) */
  message?: string;
}

/**
 * Check if an API error response indicates a "User not found" scenario
 * @param errorBody - The parsed error response body
 * @returns true if the error indicates user not found, false otherwise
 */
export function isUserNotFoundError(errorBody: ApiErrorResponse): boolean {
  const message = errorBody.error_description ?? errorBody.message ?? errorBody.error;
  return message?.includes('User not found') ?? false;
}
